export default function checkStatus(response) {
  if (response.statusCode >= 200 && response.statusCode < 300) {
    return response
  } else {
    throw response
  }
}
